import { TABLE_ROW_HEIGHT } from 'app/constants'
import { RefObject } from 'react'

class ProductService {
  getVisibleTableRows = (ref: RefObject<HTMLDivElement | null>) =>
    ref.current ? Math.floor(ref.current.clientHeight / TABLE_ROW_HEIGHT) : 0
}

export const productService = new ProductService()
